"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Avatar = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "1 -1 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.438 6.375a3.438 3.438 0 11-6.876 0 3.438 3.438 0 016.875 0zm4.687-5v11.25a1.25 1.25 0 01-1.25 1.25H2.125a1.25 1.25 0 01-1.25-1.25V1.375a1.25 1.25 0 011.25-1.25h13.75a1.25 1.25 0 011.25 1.25zm-1.25 11.25V1.375H2.125v11.25h1.147A6.25 6.25 0 015.57 9.903a.312.312 0 01.377.024 4.674 4.674 0 006.106 0 .313.313 0 01.377-.024 6.249 6.249 0 012.298 2.722h1.147z",
  fill: "#1973E8",
  className: "fill"
}));
var _default = exports.default = Avatar;